import { BaseCheckpointModel } from '../BaseCheckpointModel';
export class InternetAndMediaCheckpoint extends BaseCheckpointModel {
    constructor(checkpoint) {
        super(checkpoint);
        Object.assign(this, checkpoint);
        this.internetOccurances.map((educations, index) => {
        });
    }
}
